/* eslint-disable @next/next/no-img-element */
import Link from 'next/link'
import * as React from 'react'

import { SignUpForm } from '@/components/forms/auth/sign-up-form'

import { NON_FSDS_DEFAULT_LOGO_URL } from '@/configs/non-fsds-config'

export default function NonFsdsSignUpPage() {
  return (
    <div className="min-h-svh flex items-center justify-center bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row-reverse w-full max-w-6xl bg-white rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1)] overflow-hidden">
        {/* Right Side / Visuals (Using row-reverse) */}
        <div className="hidden lg:flex lg:w-5/12 bg-gradient-to-bl from-blue-900 to-blue-700 p-12 flex-col justify-between relative overflow-hidden text-white">
          <div className="absolute top-0 right-0 w-full h-full opacity-30 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-blue-400 via-transparent to-transparent" />
          <div className="absolute -bottom-32 -left-32 w-[30rem] h-[30rem] rounded-full bg-white/5 blur-3xl" />

          <div className="relative z-10 flex justify-end">
            <Link href="/" className="inline-block transition-transform hover:scale-105 active:scale-95 duration-200">
              <img src={NON_FSDS_DEFAULT_LOGO_URL} alt="Logo" className="h-10 w-auto" />
            </Link>
          </div>

          <div className="relative z-10 mt-auto text-right">
            <h2 className="text-4xl font-bold tracking-tight mb-4 text-white leading-tight">
              Start Your <br />
              Journey
            </h2>
            <p className="text-blue-100/90 text-lg ml-auto max-w-[22rem] leading-relaxed">
              Create an account to gain access to world-class curriculum and kickstart your learning experience today.
            </p>
          </div>
        </div>

        {/* Left Side: Form */}
        <div className="w-full lg:w-7/12 p-8 sm:p-12 lg:px-16 lg:py-14 flex flex-col justify-center bg-white relative z-10">
          <div className="mx-auto w-full max-w-md">
            <div className="lg:hidden mb-10 flex justify-center">
              <Link href="/" className="inline-block">
                <img src={NON_FSDS_DEFAULT_LOGO_URL} alt="Logo" className="h-10 w-auto" />
              </Link>
            </div>

            <h3 className="text-2xl font-bold text-slate-900 mb-2">Create an Account</h3>
            <p className="text-slate-500 mb-8 text-sm">Please enter your details below to sign up.</p>

            <SignUpForm buttonClassName="w-full bg-blue-600 text-white shadow-lg shadow-blue-600/25 transition-all duration-200 hover:bg-blue-700 hover:shadow-blue-600/40 focus-visible:ring-blue-600 rounded-xl" />

            <div className="mt-8 text-center text-sm text-slate-500">
              Already have an account?{' '}
              <Link
                href="/sign-in"
                className="font-semibold text-blue-600 transition-colors hover:text-blue-700 hover:underline underline-offset-4"
              >
                Log in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
